import { createRouter, createWebHistory } from 'vue-router';
import { landingCheck } from "@/router/navigation-guards/landing-check";
import { upsellCheck } from "@/router/navigation-guards/upsell-check";

const routes = [{
        path: '/',
        name: 'home',
        component: () => import('@/views/HomePageView/index.vue'),
    },
    {
        path: '/survey/:survey',
        name: 'survey',
        component: () => import('@/views/QuizFlow/index.vue'),
    },
    {
        path: '/EmailAdress',
        name: 'EmailAddress',
        component: () => import('@/views/EmailAddressView/index.vue')
    },
    {
        path: '/landing',
        name: 'landing',
        component: () => import('@/views/LandingView/index.vue'),
        beforeEnter: landingCheck
    },
    {
        path: '/AddressPage',
        name: 'AddressPage',
        component: () => import('@/views/AddressPage.vue'),
    },
    {
        path: '/Landing_ios_v1',
        name: 'Landing_ios_v1',
        props: true,
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_ios_v2',
        name: 'Landing_ios_v2',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_ios_v3',
        name: 'Landing_ios_v3',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_ios_v4',
        name: 'Landing_ios_v4',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_ios_v5',
        name: 'Landing_ios_v5',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_android_v1',
        name: 'Landing_android_v1',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_android_v2',
        name: 'Landing_android_v2',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_android_v3',
        name: 'Landing_android_v3',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/Landing_android_v4',
        name: 'Landing_android_v4',
        component: () => import('@/views/LandingsEmailPages/index.vue'),
    },
    {
        path: '/PlanFinalTwo',
        name: 'PlanFinalTwo',
        component: () => import('@/views/PlanFinalView/index.vue'),
        beforeEnter: upsellCheck,
        props: true
    },
    {
      path: '/PlanFinalTwo_ios',
      name: 'PlanFinalTwo_ios',
      component: () => import('@/views/PlanFinalTwo_ios.vue'),
    },
    {
      path: '/final',
      name: 'Whatsapp',
      component: () => import('@/views/FinalPageView/index.vue'),
    },
    {
      path: '/bill',
      name: 'bill',
      component: () => import('@/views/BillingPage.vue'),
    },
    {
        path: '/the-best-thing',
        name: 'best-thing',
        component: () => import('@/views/QuizFlow/components/BestThingScreen.vue'),
    },
    {
        path: '/comfortable-amount',
        name: 'comfortable-amount',
        component: () => import('@/views/ComfortableTrialAmount.vue')
    },
    {
        path: '/images',
        name: 'images',
        component: () => import('@/views/ImagesTest.vue'),
        beforeEnter: (to, from, next) => {
            if (to.query.access) next()
            else next({name: 'home'})
        }
    },
    {
        path: '/:pathMatch(.*)',
        component: () => import('@/views/NotFound.vue'),
    },
    {
        path: '/sexology-courses',
        name: 'SexologyCourses',
        component: () => import('@/views/SexologyCourses/SexologyCourses.vue'),
    },
    {
        path: '/ignoring-mental-side',
        name: 'IgnoringMentalSide',
        component: () => import('@/views/SexologyCourses/IgnoringMentalSide.vue'),
    },
    {
        path: '/sexology-courses-super',
        name: 'SexologySuperDisc',
        component: () => import('@/views/SexologyCourses/SexologyCoursesSuperDisc.vue'),
    },
    {
        path: '/verify-account-details',
        name: 'VerifyAccountDetails',
        component: () => import('@/views/VerifyAccountDetails.vue'),
    }

];

window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.path !== from.path) {
            return { top: 0};
        }
    },
});


router.beforeEach((to, from, next) => {
    document.body.style.overflow = 'auto';
    window.scrollTo({top: 0, left: 0, behavior: 'instant' });
    const IsItABackButton = window.popStateDetected;
    const backFromLanding = from.name === 'landing' && to.name === 'EmailAddress';
    const backFromPlanFinalTwo = from.name === 'PlanFinalTwo' && to.name === 'landing' || from.name === 'PlanFinalTwo' && to.name === 'AddressPage';
    const backFromAddressPage = from.name === 'AddressPage' && to.name === 'landing';
    const backFromWhatsapp = from.name === 'Whatsapp' && to.name === 'PlanFinalTwo';

    const stopPagesBack = backFromLanding || backFromPlanFinalTwo || backFromAddressPage || backFromWhatsapp;

    window.popStateDetected = false;
    if (IsItABackButton && stopPagesBack) {
        next(false)
        return ''
    }
    next();
});

export default router;
